import React from "react";

/**
 * DS SectionCard — figma 269:192 (등 카드 wrapper).
 *
 * white bg, radius 12, padding 24, gap 24 column.
 *
 * 사용:
 *  <DSSectionCard title="제품 정보">
 *    <DSFormRow label="제품 이름" required>...</DSFormRow>
 *  </DSSectionCard>
 *
 * 또는 헤더에 우측 액션 (e.g. 옵션 추가 button-mini):
 *  <DSSectionCard
 *    title="옵션 정보 (SKU)"
 *    count={1}
 *    actions={<DSButtonMini ...>옵션 추가</DSButtonMini>}
 *  >
 *
 * 타이틀: Pretendard SemiBold 18/28 Text/Primary
 * 카운트: 같은 줄에 옆 배치 (옵션) — Text/Accent
 */
const DSSectionCard = ({
  title,
  count,
  subTitle,
  actions,
  children,
  className = "",
}) => {
  return (
    <section className={`ds-section-card ${className}`}>
      {(title || actions) && (
        <header className="ds-section-card__header">
          <div className="ds-section-card__title-wrap">
            <div className="ds-section-card__title-row">
              {title && <h2 className="ds-section-card__title">{title}</h2>}
              {count != null && (
                <span className="ds-section-card__count">{count}개</span>
              )}
            </div>
            {/* subTitle — 카드 헤더 아래 설명 텍스트 (figma 390:6044 등) */}
            {subTitle && (
              <div className="ds-section-card__sub-title">{subTitle}</div>
            )}
          </div>
          {actions && <div className="ds-section-card__actions">{actions}</div>}
        </header>
      )}
      <div className="ds-section-card__body">{children}</div>
    </section>
  );
};

/**
 * Form row: 좌측 label(183w) + 우측 content(flex-1), gap=20, align=start
 */
const DSFormRow = ({ label, required, children, labelWidth = 183, className = "" }) => {
  return (
    <div className={`ds-form-row ${className}`}>
      {label != null && (
        <div className="ds-form-row__label" style={{ width: labelWidth }}>
          <span className="ds-form-row__label-text">{label}</span>
          {required && <span className="ds-form-row__required" aria-hidden>*</span>}
        </div>
      )}
      <div className="ds-form-row__body">{children}</div>
    </div>
  );
};

DSSectionCard.FormRow = DSFormRow;
export { DSFormRow };
export default React.memo(DSSectionCard);
